<template>
  <div class="article-list">
    <HomeList :getListApi="getbusinesses" :params="homeListParams">
      <template>
        <ArticleItem
          v-for="(item, index) in articleList"
          :key="index"
          :articleInfo="item"
          @goDes="goDes"
        ></ArticleItem>
      </template>
    </HomeList>
  </div>
</template>
<script>
import HomeList from 'component/platform/homepage/common/homeList.vue'
import ArticleItem from 'component/platform/homepage/normalUser/articleItem.vue'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
export default {
  props: {},
  mixins: [homepageMixin],
  components: {
    HomeList,
    ArticleItem
  },
  data() {
    return {
      homeListParams: {}
    }
  },
  computed: {
    articleList() {
      return this.$store.getters['homepage/getTabListData']('article') || []
    }
  },
  created() {},
  mounted() {
    // 获取token, 再发起请求
    this.mixinGetToken().then(token => {
      this.token = token
      this.homeListParams = {
        user_id: this.$route.params.userId,
        token: token,
        business_type: 'article'
      }
    })
  },
  methods: {
    goDes() {
      this.$trackEvent('newprofilepages_article_click', {})
    },
    getbusinesses(params) {
      return this.$store.dispatch('homepage/fetchBusinesses', params)
    }
  }
}
</script>
<style lang="scss" scoped>
.article-list {
  margin: 30px 0;
}
</style>
